import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/" className="logo">
        <span style={{ fontWeight: "bold", paddingRight:"5px" }}>
          PredPPI-GReMLIN | 
        </span>{" "}
        Protein-Protein Interaction & Ligand Prediction Tool
      </Link>
      <ul className="nav-links">
        {/* <li><Link to="/">Home</Link></li> */}
        {/* <li><Link to="/about">About</Link></li> */}
        <li><Link to="/contact">Contact</Link></li>
        <li><Link to="/services">Help</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
